import { VehicleConstant } from '../constants';
import { RequestAction } from '.';

export const createVehicle = data =>
  RequestAction.request(VehicleConstant.CREATE_VEHICLE, {
    data,
    method: 'post',
    url: `/api/vehicle`,
  });

export const deleteVehicle = id =>
  RequestAction.request(VehicleConstant.DELETE_VEHICLE, {
    method: 'delete',
    url: `/api/vehicle/${id}`,
  });

export const editVehicle = (id, data) =>
  RequestAction.request(VehicleConstant.EDIT_VEHICLE, {
    data,
    method: 'put',
    url: `/api/vehicle/${id}`,
  });

export const getVehicle = id =>
  RequestAction.request(VehicleConstant.GET_VEHICLE, {
    url: `/api/vehicle/${id}`,
  });

export const getVehicles = params =>
  RequestAction.request(VehicleConstant.GET_VEHICLES, {
    params,
    url: '/api/vehicle',
  }, false);

export const setVehicle = payload => ({
  payload,
  type: VehicleConstant.SET_VEHICLE,
});

export const setVehicles = payload => ({
  payload,
  type: VehicleConstant.SET_VEHICLES,
});
